//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EndEvent from './endEvent';
import AutoRepeat from './autoRepeat';

export default {
  name: 'WorkflowAdvanceConfig',
  components: { EndEvent, AutoRepeat },
  props: {
    actionList: {
      type: Array,
      default: () => [],
    },
    autoRepeat: {
      type: Number,
      default: 1,
    },
    advanceSelectAssigners: {
      type: Array,
      default: () => [],
    },
    neighborSet: {
      type: Number,
      default: 1,
    },
    budgetSwitch: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // 侧边tab列表与当前值
      sideTabList: [
        {
          name: 'ended',
          label: '审批流结束事件',
        },
        {
          name: 'repeat',
          label: '审批设置',
        },
      ],
      sideTab: 'ended',
    };
  },
  methods: {
    update(type, value) {
      this.$emit('update', {
        type,
        value,
      });
    },
  },
};
